import { ClassNames } from "@emotion/react"
import React from "react"
import tw from "twin.macro"

const Callout = ({ children, color, centered, marginBottom, extraClasses }) => {
  return (
    <div
      className={`${extraClasses}`}
      css={[
        tw`rounded-tl-xl rounded-br-xl px-10 py-7 lg:(px-7 py-6)`,
        color === "blue" && tw`bg-blue text-white`,
        color === "yellow" && tw`bg-yellow text-black`,
        color === "grey" && tw`bg-grey text-blue`,
        centered && tw`text-center`,
      ]}
    >
      {children}
    </div>
  )
}

export default Callout
